import Usuario from "../domain/Usuario"
import ApiServiceAdapter from "../infraestructure/ApiServiceAdapter"

class UsuarioService {
  constructor(usuario, password) {
    this.apiService = new ApiServiceAdapter()
    this.usuario = usuario
    this.password = password
  }

  async validarUsuario() {
    try{
      const usuarioData = await this.apiService.fethValidarUsuario(this.usuario, this.password, "RSV")
      const uss = new Usuario(
        usuarioData.idusuario,
        usuarioData.nombreCompleto,
        usuarioData.usuario,
        usuarioData.autorizado,
        usuarioData.token,
        usuarioData.roles,
        (usuarioData.idUsuarioDeAplicacion === null ? -1 : usuarioData.idUsuarioDeAplicacion)
      )
      return uss
    } catch (error) {
      // Manejar errores de la llamada a la API
      throw new Error('Error al validar usuario');
    }
  }
} 

export default UsuarioService
